// Module
var code = "<div class=\"row\"> <div class=\"col\"> <maintenance-users-list selected-business-id=\"$ctrl.selectedBusinessId\" on-grid-need-resize=\"$ctrl.handleGridNeedResize\"></maintenance-users-list> </div> </div> ";
// Exports
export default code;